<template>
  <div v-if="img">
    <race-img
      :buttons="buttons"
      :car-number="carNumber"
      :height="height ? height - 10 + 'px' : '100%'"
      :is-comment="!!comment"
      :is-feedback="img.in_feedbacks"
      :menu-items="menuItems"
      :outlined="contextMenu.id === img._id"
      :show-numbers="raceFilters.showNumbers"
      :show-actions="raceFilters.showOptions"
      :show-tags="raceFilters.showTags"
      :src="imgSrc"
      :tags="tags"
      :time="time"
      @comment="openCommentDialog"
      @feedback="feedback"
      @handleContextMenu="handleContextMenu"
      @viewImage="viewImage"
    />
    <v-menu
      v-if="contextMenu.id === img._id"
      absolute
      offset-y
      :position-x="contextMenu.x"
      :position-y="contextMenu.y"
      :value="true"
      @input="resetRaceContextMenu"
    >
      <v-list>
        <v-list-item
          v-for="item in [...buttons, ...menuItems]"
          tag="button"
          :key="item.title"
          @click="item.action"
        >
          <v-list-item-title :style="{ color: item.color || 'white' }">
            <v-icon
              class="action-icon"
              size="20"
              :color="item.color || 'white'"
            >
              {{ item.icon }}
            </v-icon>
            {{ item.title }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <CommentDialog
      :value="comment"
      :visible="isShowCommentModal"
      @close="commentDialogCloseHandler"
      @submit="submitCommentHandler"
    />
    <SubmitDialog
      submitText="Delete"
      text="Are you sure you want to delete the picture?"
      :visible="isShowSubmitRemoveModal"
      @close="submitRemoveDialogCloseHandler"
      @submit="removeImage"
    />
  </div>
</template>

<script>
import { getImageTags } from "@/utils/helpers";
import utils from "@/utils/utils";
import {
  postFavoritesRaceImages,
  deleteFavoritesRaceImages,
  putFavoritesRaceImages,
} from "../../api/raceimages";
import { deleteImage } from "../../api/images";
import CommentDialog from "../../components/dialogs/CommentDialog";
import RaceImg from "./RaceImg";
import SubmitDialog from "../../components/dialogs/SubmitDialog";
import { mapActions, mapGetters } from "vuex";
import { postFeedback, deleteFeedback } from "../../api/feedback";

export default {
  name: "RaceImgCard",
  components: {
    CommentDialog,
    RaceImg,
    SubmitDialog,
  },
  props: {
    cropImageView: {
      type: Boolean,
    },
    imgProp: {
      type: Object,
      required: true,
    },
    height: {
      type: [Number, String],
    },
    filters: {
      type: Object,
      default() {
        return {};
      },
    },
    raceFilters: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      contextMenu: "race/contextMenu",
    }),
    buttons() {
      return [
        {
          action: this.addToCompareBtnClickHandler,
          icon: "$vuetify.icons.compare",
          title: "Compare",
        },
        {
          action: this.favoriteBtnClickHandler,
          icon: this.img.favorite
            ? "$vuetify.icons.minus"
            : "$vuetify.icons.plus",
          title: this.img.favorite ? "Remove from favorite" : "Favorite",
        },
        {
          action: this.viewImage,
          icon: "$vuetify.icons.eye",
          title: "View",
        },
        {
          action: this.feedback,
          color: "var(--v-warning-base)",
          icon: "$vuetify.icons.report",
          title: "Report",
        },
        {
          action: this.actionNotAssigned,
          icon: "$vuetify.icons.edit",
          title: "Edit",
        },
      ];
    },
    imgSrc() {
      return this.cropImageView && this.img.smart_zoom_thumbnail_url
        ? this.img.smart_zoom_thumbnail_url
        : this.img.thumbnail_url;
    },
    menuItems() {
      return [
        {
          action: this.handleDownload,
          icon: "$vuetify.icons.download",
          title: "Download",
        },
        {
          action: this.openCommentDialog,
          icon: "$vuetify.icons.message",
          title: "Comment",
        },
        {
          action: this.openSubmitRemoveModal,
          color: "var(--v-error-base)",
          icon: "$vuetify.icons.trash",
          title: "Delete",
        },
      ];
    },
    carNumber() {
      let carNumbers = this.img.tags
        .filter(({ car_number }) => car_number !== "n/a")
        .map(({ car_number }) => car_number)
        .sort();
      carNumbers = carNumbers.filter(
        (carNumber, index) => carNumbers.indexOf(carNumber) === index
      );
      if (
        this.filters &&
        this.filters.car_number &&
        this.filters.car_number.length
      ) {
        carNumbers = carNumbers.sort((a) =>
          this.filters.car_number.includes(a) ? -1 : 1
        );
      }
      if (carNumbers.length > 1) {
        return `${carNumbers[0]}, ${carNumbers[1]}`;
      } else if (carNumbers.length > 0) {
        return `${carNumbers[0]}`;
      }
      return "";
    },
    tags() {
      return getImageTags(this.img);
    },
    time() {
      if (this.img.created_time) {
        return this.img.created_time;
      }
      const date = new Date(this.img.created_date);
      return `${date.getHours()}:${date
        .getMinutes()
        .toString()
        .padStart(2, "0")}:${date.getSeconds().toString().padStart(2, "0")}`;
    },
  },
  data() {
    return {
      img: null,
      comment: "",
      isShowCommentModal: false,
      isShowSubmitRemoveModal: false,
      isLoadImg: true,
      baseAPIURL: process.env.VUE_APP_BASE_API_URL,
    };
  },
  methods: {
    ...mapActions({
      resetRaceContextMenu: "race/resetRaceContextMenu",
      setContextMenu: "race/setRaceContextMenu",
      actionNotAssigned: "notification/actionNotAssigned",
      addImageToCompares: "race/addImageToCompares",
      notificationSucces: "notification/success",
    }),
    handleContextMenu(e) {
      this.setContextMenu({
        id: this.img._id,
        x: e.clientX,
        y: e.clientY,
      });
    },
    handleDownload() {
      utils.downloadFile(`${this.baseAPIURL}download/images/${this.img._id}`, {
        target: "_blank",
      });
    },
    loadH() {
      this.isLoadImg = false;
    },
    favoriteBtnClickHandler() {
      if (this.img.favorite) {
        let params = {
          favorites_images: this.img._id,
        };
        deleteFavoritesRaceImages(params).then((res) => {
          this.img.favorite = false;
          this.notificationSucces("Removed from Favorites");
          return res;
        });
      } else {
        postFavoritesRaceImages([this.img._id]).then((res) => {
          this.$nextTick(() => {
            this.img.favorite = true;
          });
          this.notificationSucces("Added to Favorites");
          return res;
        });
      }
    },
    viewImage() {
      // this.$router.push({ name: 'image', params: { imageId: this.img._id } })
      this.$emit("selectImg", this.img._id);
    },
    commentDialogCloseHandler() {
      this.isShowCommentModal = false;
    },
    submitRemoveDialogCloseHandler() {
      this.isShowSubmitRemoveModal = false;
    },
    submitCommentHandler(val) {
      putFavoritesRaceImages({ image_id: this.img._id, comment: val })
        .then(() => {
          this.comment = val;
          this.notificationSucces("Comment saved");
          this.commentDialogCloseHandler();
        })
        .catch(() => {
          this.$store.dispatch("notification/error", "Failed to save comment");
        });
    },
    openCommentDialog() {
      this.isShowCommentModal = true;
    },
    openSubmitRemoveModal() {
      this.isShowSubmitRemoveModal = true;
    },
    addToCompareBtnClickHandler() {
      const compareImage = {
        id: this.img._id,
        thumbnailURL: this.imgSrc,
        raceId: this.img.race_id,
      };
      this.addImageToCompares(compareImage);
    },
    removeImage() {
      return deleteImage(this.img._id).then((res) => {
        this.img = null;
        this.submitRemoveDialogCloseHandler();
        return res;
      });
    },
    feedback() {
      if (this.img.in_feedbacks) {
        return deleteFeedback(this.img._id).then((res) => {
          this.notificationSucces("The issue report was removed");
          this.img.in_feedbacks = false;
          return res;
        });
      }
      return postFeedback([this.img._id]).then((res) => {
        this.notificationSucces(
          "The issue report was sent. Auto-tags model will be updated after the review"
        );
        this.img.in_feedbacks = true;
        return res;
      });
    },
  },
  mounted() {
    this.img = { ...this.imgProp };
    this.comment = this.imgProp.comment;
  },
};
</script>

<style lang="scss" scoped>
.action-icon {
  ::v-deep {
    circle {
      fill: currentColor;
    }

    path,
    rect {
      stroke: currentColor;
      fill: none;
    }
  }
}

::v-deep {
  .v-list {
    background: rgba(0, 0, 0, 0.87);
  }

  .v-list-item {
    min-height: 32px;
    width: 100%;

    &:hover {
      background: rgba(255, 255, 255, 0.26);
    }
  }

  .v-list-item__title {
    display: flex;
    gap: 16px;
  }
}
</style>
